var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.25V5.75C5.5 4.55653 5.97411 3.41193 6.81802 2.56802C7.66193 1.72411 8.80653 1.25 10 1.25V1.25C11.1935 1.25 12.3381 1.72411 13.182 2.56802C14.0259 3.41193 14.5 4.55653 14.5 5.75V7.25M1.75 7.25C1.55109 7.25 1.36032 7.32902 1.21967 7.46967C1.07902 7.61032 1 7.80109 1 8V18.125C1 19.5425 2.2075 20.75 3.625 20.75H16.375C17.7925 20.75 19 19.6011 19 18.1836V8C19 7.80109 18.921 7.61032 18.7803 7.46967C18.6397 7.32902 18.4489 7.25 18.25 7.25H1.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBag);
export default __webpack_public_path__ + "static/media/cart-bag.80a572230fafda638e95eebda5245aba.svg";
export { ForwardRef as ReactComponent };